function toNiceTimestamp(
  time: string | number | Date,
  include_time?: boolean,
): string {
  if (!time) return '';

  // Handle different timestamp formats
  let date: Date;

  if (typeof time === 'string') {
    // If the string doesn't end with 'Z' or have timezone info, assume it's UTC
    // Look for timezone indicators after the time part (after seconds)
    const hasTimezone =
      time.includes('Z') ||
      (time.includes('+') && time.indexOf('+') > 10) ||
      (time.includes('-') && time.indexOf('-') > 10);

    if (!hasTimezone) {
      // Convert "YYYY-MM-DD HH:MM:SS" format to ISO string
      const isoString = time.replace(' ', 'T') + 'Z';
      date = new Date(isoString);
    } else {
      date = new Date(time);
    }
  } else {
    date = new Date(time);
  }

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  return new Intl.DateTimeFormat(
    Intl.DateTimeFormat().resolvedOptions().locale,
    {
      dateStyle: 'medium',
      timeStyle: include_time ? 'medium' : undefined,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  ).format(date);
}

export default toNiceTimestamp;
